import { Autocomplete, Button, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { formStyle } from '../../TransitionStyles';

FreeSoloAutocompleteInput.propTypes = {
  fieldName: PropTypes.string,
  options: PropTypes.array,
  isEditable: PropTypes.bool,
  saveNewValue: PropTypes.func,
  placeholder: PropTypes.string,
  additionalCheck: PropTypes.func,
};

export default function FreeSoloAutocompleteInput({
  fieldName,
  options,
  isEditable,
  saveNewValue,
  placeholder,
  additionalCheck = () => true,
}) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({ name: fieldName, control });
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);
  const [inputValue, setInputValue] = useState('');

  const selectedOption =
    options?.find((opt) => String(opt.value) === String(field?.value?.value) && additionalCheck(opt, field?.value)) ||
    field?.value;

  const autocompleteValue = selectedOption ?? null;

  function filterAutocompleteOptions(options, inputValue) {
    const filtered = options.filter((o) => o.label.toLowerCase().includes(inputValue.toLowerCase()));

    const exists = options.some((o) => o.label.toLowerCase() === inputValue.toLowerCase());

    if (inputValue !== '' && !exists) {
      filtered.push({
        value: null,
        isAdd: true,
        label: inputValue,
      });
    }

    return filtered;
  }

  function renderOptionList(props, option) {
    if (option.isAdd) {
      return (
        <li {...props}>
          <Button variant="contained" color="secondary">
            Add "{option.label}"
          </Button>
        </li>
      );
    }

    return <li {...props}>{option.label}</li>;
  }

  return (
    <Autocomplete
      key={field.id}
      freeSolo
      forcePopupIcon
      onKeyDown={(e) => {
        if (e.key === 'Enter') e.preventDefault();
      }}
      filterOptions={(options, params) => filterAutocompleteOptions(options, params.inputValue)}
      options={options ?? []}
      getOptionLabel={(opt) => opt?.label || ''}
      renderOption={(props, option) => renderOptionList(props, option)}
      value={autocompleteValue}
      disabled={!isEditable || isCanceled}
      inputValue={inputValue}
      onInputChange={(_, newInputValue) => {
        setInputValue(newInputValue);
      }}
      onBlur={() => {
        if (field?.value?.label !== inputValue) {
          setInputValue('');
        }
      }}
      onChange={(_, value) => {
        if (value?.isAdd) saveNewValue(value);
        else field.onChange(value);
      }}
      isOptionEqualToValue={(option, value) => option.value === value?.value && additionalCheck(option, value)}
      renderInput={(paramsInput) => (
        <TextField
          {...paramsInput}
          inputRef={field.ref}
          fullWidth
          size="small"
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          sx={formStyle}
          autoComplete="off"
          placeholder={placeholder}
        />
      )}
    />
  );
}
